import { createRouter, createWebHistory } from 'vue-router';
// import store from '../store/index';
import boardRoutes from './modules/board';
import parkingRoutes from './modules/parking';
import prepaymentRoutes from './modules/prepayment';
import unpaidRoutes from './modules/unpaid';
import utilRoutes from './modules/util';

import ErrorPage from '@/html/subpage/util/ErrorPage.vue';

const routes = [
  {
    path: '/',
    redirect: '/main',
  },
  {
    path: '/main',
    name: 'main',
    component: () =>
      import(
        /* webpackChunkName: "view-main-vue" */ '@/html/mainpage/mainPage'
      ),
    meta: { category: ['메인', '메인'] },
  },
  ...boardRoutes,
  ...parkingRoutes,
  ...prepaymentRoutes,
  ...unpaidRoutes,
  ...utilRoutes,
  // Not Found Page
  {
    path: '/404',
    name: 'notFound',
    component: ErrorPage,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
];

const router = createRouter({
  history: createWebHistory(),
  //   createWebHistory(
  //   process.env.NODE_ENV !== 'local' ? process.env.VUE_APP_PATH : '/',
  // ),
  routes,
  scrollBehavior() {
    // 페이지 새로고침 시 스크롤을 최상단으로 이동
    return { top: 0 };
  },
});

// 최상단 스크롤 함수
function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  } else {
    return { top: 0 };
  }
}

// router.beforeEach((to, from, next) => {
//   const isLogin = store.state.isLogin;
//   const empDiv = store.state.empDiv;
//   const { empcategory } = to.meta;

//   if (to.matched.some(record => record.meta.authorization)) {
//     if (!isLogin) {
//       next('/login');
//       return;
//     }
//   }

//   if (to.matched.some(record => record.meta.empcategory)) {
//     if (!empcategory.includes(empDiv)) {
//       if (empDiv === 'USR') {
//         alert('해당서비스는 사업자 회원만 이용할 수 있습니다.');
//         next('/main');
//         return;
//       }
//       if (empDiv === 'BSN') {
//         alert('해당서비스는 일반 회원만 이용할 수 있습니다.');
//         next('/main');
//         return;
//       }
//       alert('접근 권한이 존재하지 않습니다.');
//       next('/loginmain');
//       return;
//     }
//   }

//   if (to.matched.some(record => record.meta.onlyGuest)) {
//     if (isLogin) {
//       return next({ path: '/main' });
//     }
//   }

//   next();
// });

// 라우터 이동시 스크롤 위치를 최상단으로 이동
router.afterEach((to, from) => {
  window.scrollTo(scrollBehavior(to, from, null));
});

export default router;
